import React from 'react'
import { Field } from 'redux-form'

const SelectField = ({
  name,
  label,
  options,
  placeholder,
  onChange,
  className,
  valueObj,
  nameObj,
  disabled,
  defaultValue,
  labelStyling,
}) => {
  const WrappedSelectField = ({ label, input, name, children, onChange, className, disabled }) => (

    <div>
      {label && (
        <label
          htmlFor={name}
          className={labelStyling ? labelStyling : null}
          style={labelStyling ? { fontSize: '1.5rem' } : { marginBottom: '0px', }}
        >
          {label}
        </label>
      )}
      <select
        id={name}
        {...input}
        value={input.value !== undefined && input.value !== null ? input.value : defaultValue}
        disabled={disabled}
        onChange={value => input.onChange(value) && onChange(value)}
        className={`form-control select__popup ${className}`}
        style={{ margin: '0px', }}
      >
        {children}
      </select>
    </div>
  )
  return (
    <Field
      onChange={onChange}
      name={name}
      component={WrappedSelectField}
      className={className}
      label={label}
      disabled={disabled}
      defaultValue={defaultValue}
    >
      {placeholder && <option value=''>{placeholder}</option>}
      {options &&
        options.map((option, index) => {
          const optionValue = option[valueObj] ?? option.value ?? option.group_id ?? option.xp_key ?? option.gid ?? option.eyid ?? option.trmid;
          return (
            <option key={`${index} ${optionValue}}`} value={optionValue}>
              {option[nameObj] || option.name || option.groupname || option.title}
            </option>
          );
        })}
    </Field>
  )
}

export default SelectField
